import React, { Fragment } from 'react';
import { connect } from "react-redux";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
import ButtonContent from '../ButtonContent';
import withAuth from '../../hocs/withAuth';
import { COLORS } from '../../styles/colors'

class RestrictFeature extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: props.isOpenAddModal,
        }
    }

    onClose = () => this.setState({ show: false }, () => this.props.hideAddModal());

    render() {
        let { isMobile, history  } = this.props;
        const { show } = this.state;
        return (
            <Modal
                className="modal show"
                open={show}
                onClose={this.onClose}
            >
                <div className="modalBody modal-content" style={{ width: isMobile ? '100%' : 650, height: 300 }}>
                        <Fragment>
                            <ModalHeading
                                text={"Unlock Pro!"}
                                closeModal={this.onClose}
                            />
                            <div className="modalContent">
                            Please upgrade your plan to unlock more features.
                               <div style={{
                                 textAlign: 'center',
                                 marginTop: '30'
                               }}>
                               <Button variant="outlined" style={{
                                  backgroundColor: COLORS.orange,
                                  color: COLORS.white
                                 }}  
                                 onClick={() => {
                                    history.push('/selectMembersipPlan')
                                 }}> Upgrade Now
                               </Button>
                               </div>
                
                            </div>
                        </Fragment>
                    
                    
                </div>
            </Modal>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        errors: state.errors
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(RestrictFeature));



// WEBPACK FOOTER //
// ./src/components/membershipPlan/restrictFeature.js